const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || '';
const ZKL_URL = process.env.REACT_APP_ZKL_URL || '';

export function getZklUrl() {
    return `${ZKL_URL}/account/action/change-mobilephone?callback_uri=${PUBLIC_URL}refresh&callback_client=digitale_kreditauszahlung`;
}
